import { render, staticRenderFns } from "./VH_permanent.vue?vue&type=template&id=027f738a"
import script from "./VH_permanent.vue?vue&type=script&lang=js"
export * from "./VH_permanent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports